import script from "./header.vue?vue&type=script&setup=true&scoped=true&lang=js"
export * from "./header.vue?vue&type=script&setup=true&scoped=true&lang=js"

import "./header.vue?vue&type=style&index=0&id=52b4ba43&lang=scss"

const __exports__ = script;

export default __exports__